import ChargeHelper from 'features/Charge/chargeHelper';
import KTFormSearch from 'general/components/OtherKeenComponents/Forms/KTFormSearch';
import KTBSDropdown, { KTBSDropdownDirections } from 'general/components/OtherKeenComponents/KTBSDropdown';
import CustomDateRangePicker, {
  dateFilter,
  getDateFilterOption,
} from 'general/components/Others/CustomDateRangePicker';
import AppColors from 'general/constants/AppColors';
import AppConfigs from 'general/constants/AppConfigs';
import UIHelper from 'general/helpers/UIHelper';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useEffect, useMemo, useState } from 'react';

ChargeDriverListFilterView.propTypes = {
  onCancel: PropTypes.func,
  onApply: PropTypes.func,
  closeDropdown: PropTypes.func,
};

export function chargeDriverListPickerFilterComponent(dateFilterKey, storedFrom, storedTo) {
  if (storedFrom && storedTo) {
    return { from: storedFrom, to: storedTo };
  }
  const range = getDateFilterOption(dateFilterKey || dateFilter.tatCaThoiGian);
  return {
    from: range[0].format('YYYY-MM-DD'),
    to: range[1].format('YYYY-MM-DD'),
  };
}

function ChargeDriverListFilterView({ onCancel, onApply, closeDropdown }) {
  // MARK: ---- PROPERTIES ----
  const [filterQ, setFilterQ] = useState('');
  const [filterStatus, setFilterStatus] = useState('');
  const [filterPricingType, setFilterPricingType] = useState('');
  const [filterDateFilter, setFilterDateFilter] = useState(dateFilter.tatCaThoiGian);
  const [filterFrom, setFilterFrom] = useState('');
  const [filterTo, setFilterTo] = useState('');
  const [filterTransactionDateFilter, setFilterTransactionDateFilter] = useState(
    dateFilter.tatCaThoiGian
  );
  const [filterTransactionFrom, setFilterTransactionFrom] = useState('');
  const [filterTransactionTo, setFilterTransactionTo] = useState('');

  const creationPickerFilter = useMemo(
    () => chargeDriverListPickerFilterComponent(filterDateFilter, filterFrom, filterTo),
    [filterDateFilter, filterFrom, filterTo]
  );
  const transactionPickerFilter = useMemo(
    () =>
      chargeDriverListPickerFilterComponent(
        filterTransactionDateFilter,
        filterTransactionFrom,
        filterTransactionTo
      ),
    [filterTransactionDateFilter, filterTransactionFrom, filterTransactionTo]
  );

  useEffect(() => {
    const f = ChargeHelper.Filter.chargeDriverList;
    setFilterQ(f.q);
    setFilterStatus(f.status);
    setFilterPricingType(f.pricingType ?? '');
    setFilterDateFilter(f.dateFilter ?? dateFilter.tatCaThoiGian);
    setFilterFrom(f.from ?? '');
    setFilterTo(f.to ?? '');
    setFilterTransactionDateFilter(f.transactionDateFilter ?? dateFilter.tatCaThoiGian);
    setFilterTransactionFrom(f.walletDepositFrom ?? '');
    setFilterTransactionTo(f.walletDepositTo ?? '');
  }, []);

  // MARK: ---- METHODS ----
  const persistFilter = (partial) => {
    ChargeHelper.Filter.chargeDriverList = {
      ...ChargeHelper.Filter.chargeDriverList,
      ...partial,
    };
  };

  const handleApplyFilter = () => {
    persistFilter({
      page: 0,
      status: filterStatus,
      q: filterQ,
      pricingType: filterPricingType,
      from: filterDateFilter === dateFilter.tatCaThoiGian ? '' : filterFrom,
      to: filterDateFilter === dateFilter.tatCaThoiGian ? '' : filterTo,
      dateFilter: filterDateFilter,
      walletDepositFrom:
        filterTransactionDateFilter === dateFilter.tatCaThoiGian ? '' : filterTransactionFrom,
      walletDepositTo:
        filterTransactionDateFilter === dateFilter.tatCaThoiGian ? '' : filterTransactionTo,
      transactionDateFilter: filterTransactionDateFilter,
    });
    if (onApply) onApply();
    if (closeDropdown) closeDropdown();
  };

  const handleClearFilter = () => {
    ChargeHelper.Filter.chargeDriverList = {
      page: 0,
      limit: AppConfigs.defaultPageLimit,
      q: '',
      status: '',
      pricingType: '',
      from: '',
      to: '',
      dateFilter: dateFilter.tatCaThoiGian,
      walletDepositFrom: '',
      walletDepositTo: '',
      transactionDateFilter: dateFilter.tatCaThoiGian,
    };
    setFilterQ('');
    setFilterStatus('');
    setFilterPricingType('');
    setFilterDateFilter(dateFilter.tatCaThoiGian);
    setFilterFrom('');
    setFilterTo('');
    setFilterTransactionDateFilter(dateFilter.tatCaThoiGian);
    setFilterTransactionFrom('');
    setFilterTransactionTo('');
    if (onCancel) onCancel();
    if (closeDropdown) closeDropdown();
  };

  return (
    <div className="py-4">
      <div className="row m-0 px-2">
        <div className="col-12 mb-4 px-2">
          <KTFormSearch
            name="search_filter"
            placeholder="Theo mã khách hàng, họ và tên, số điện thoại, email, biển số xe..."
            value={filterQ}
            onSubmit={(text) => {
              setFilterQ(text);
            }}
          />
        </div>

        <div className="col-6 mb-4 px-2">
          {UIHelper.buildFormLabel('Trạng thái')}
          <KTBSDropdown
            name="status_filter"
            toggleElement={
              <button
                className="btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between"
                type="button"
              >
                {_.find(ChargeHelper.Data.chargeDriverStatusOptions, (item) => item.value === filterStatus)
                  ?.name ?? 'Tất cả'}
              </button>
            }
            selectedValue={filterStatus}
            dropdownMenuItems={[
              { name: 'Tất cả', value: '' },
              ...ChargeHelper.Data.chargeDriverStatusOptions,
            ]}
            dropdownMenuClassName="overflow-auto w-100"
            dropdownMenuStyle={{ maxHeight: '30vh' }}
            onChange={(value) => setFilterStatus(value)}
            isDropdownForm={true}
          />
        </div>
        {/* loai gia sac */}
        <div className="col-6 mb-4 px-2">
          {UIHelper.buildFormLabel('Loại giá sạc')}
          <KTBSDropdown
            name="pricingType_filter"
            toggleElement={
              <button
                className="btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between"
                type="button"
              >
                {_.find(
                  ChargeHelper.Data.chargeDriverPricingTypeOptions,
                  (item) => item.value === filterPricingType
                )?.name ?? 'Tất cả'}
              </button>
            }
            selectedValue={filterPricingType}
            dropdownMenuItems={[
              { name: 'Tất cả', value: '' },
              ...ChargeHelper.Data.chargeDriverPricingTypeOptions,
            ]}
            dropdownMenuClassName="overflow-auto w-100"
            dropdownMenuStyle={{ maxHeight: '30vh' }}
            onChange={(value) => setFilterPricingType(value)}
            isDropdownForm={true}
            direction={KTBSDropdownDirections.down}
          />
        </div>

        {/* thoi gian tao */}
        <div className="col-6 mb-4 px-2">
          {UIHelper.buildFormLabel('Thời gian tạo')}
          <CustomDateRangePicker
            toggleElementBorderRadius={5}
            alignRight
            initialValue={filterDateFilter}
            defaultValue={dateFilter.tatCaThoiGian}
            filterComponent={creationPickerFilter}
            direction={KTBSDropdownDirections.down}
            onPressSave={(selectedValue, startDate, endDate) => {
              setFilterDateFilter(selectedValue);
              setFilterFrom(startDate);
              setFilterTo(endDate);
            }}
          />
        </div>
        {/* ky giao dich */}
        <div className="col-6 mb-4 px-2">
          {UIHelper.buildFormLabel('Kỳ giao dịch')}
          <CustomDateRangePicker
            toggleElementBorderRadius={5}
            alignRight
            initialValue={filterTransactionDateFilter}
            defaultValue={dateFilter.tatCaThoiGian}
            filterComponent={transactionPickerFilter}
            direction={KTBSDropdownDirections.down}
            onPressSave={(selectedValue, startDate, endDate) => {
              setFilterTransactionDateFilter(selectedValue);
              setFilterTransactionFrom(startDate);
              setFilterTransactionTo(endDate);
            }}
          />
        </div>
      </div>

      <div
        className="px-4 pt-4 pb-0 d-flex align-items-center justify-content-end gap-3"
        style={{
          borderTop: `1px solid ${AppColors.gray[200]}`,
        }}
      >
        {UIHelper.buildNegativeButton('Xóa bộ lọc', handleClearFilter)}
        {UIHelper.buildGreenButton('Áp dụng', handleApplyFilter)}
      </div>
    </div>
  );
}

export default ChargeDriverListFilterView;
